module.exports = __webpack_public_path__ + "static/img/togo.08b46ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/togo.png
// module id = g7AI
// module chunks = 0